import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { SearchNotFound } from '../Search/SearchNotFound.js';
export const TokenNotFound = () => {
    const { t } = useTranslation();
    return (_jsx(SearchNotFound, { message: t('info.message.emptyTokenListAllNetworks') }));
};
//# sourceMappingURL=TokenNotFound.js.map